import { useIntl } from "react-intl";

import { CollapsibleCard } from "@/components/CollapsibleCard/CollapsibleCard";
import type { HotelData } from "@/features/hotels/types/types";

type Props = {
  hotel: HotelData;
};

export const HotelContactDetails = ({ hotel }: Props) => {
  const intl = useIntl();

  if (!hotel.address && !hotel.email && !hotel.telephone) {
    return null;
  }

  return (
    <CollapsibleCard
      title={intl.formatMessage({
        defaultMessage: "Hotel information",
        description: "Section heading for the hotel's contact information",
      })}
      expandedByDefault={false}
    >
      <div className="flex flex-col justify-between gap-4 text-sm text-text-primary">
        {hotel.address && (
          <div className="flex justify-between gap-4">
            {intl.formatMessage({
              defaultMessage: "Address",
              description:
                "Label for the hotel's physical address on the hotel details page",
            })}
            <div className="flex w-210 flex-wrap justify-end">
              {hotel.address
                .split(",")
                .map((position: string, index: number) => (
                  <span key={position}>
                    {position}{" "}
                    {index <= hotel.address.split(",").length - 2 && "-"}
                  </span>
                ))}
            </div>
          </div>
        )}
        {hotel.email && (
          <div className="flex justify-between gap-4">
            {intl.formatMessage({
              defaultMessage: "Email",
              description: "Label for the hotel's email contact address",
            })}
            <span>{hotel.email}</span>
          </div>
        )}
        {hotel.telephone && (
          <div className="flex justify-between gap-4">
            {intl.formatMessage({
              defaultMessage: "Phone",
              description: "Label for the hotel's phone number",
            })}
            <a
              className="text-text-interactive underline"
              href={`tel:${hotel.telephone}`}
            >
              {hotel.telephone}
            </a>
          </div>
        )}
      </div>
    </CollapsibleCard>
  );
};
